import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("sbr_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

// Resolve product image URL: absolute URLs pass through; relative paths (uploads) get prefixed with backend URL
export const imgUrl = (u) => {
  if (!u) return u;
  return u.startsWith("http") ? u : `${BACKEND_URL}${u}`;
};

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);
